// extracted by mini-css-extract-plugin
export default {"divider":"login_divider__izF25","loginImage":"login_loginImage__GH7C3"};